module.exports = __webpack_public_path__ + "static/media/vivi-sorrindo-direita.080265ba.svg";